exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".accusation-service-userReport-mask-1ZfsV{background-color:#000;opacity:.2;z-index:6007;width:100%;height:100%}.accusation-service-userReport-container-2bvLY,.accusation-service-userReport-mask-1ZfsV{position:absolute;left:0;top:0;margin:auto}.accusation-service-userReport-container-2bvLY{width:381px;height:338px;z-index:9007;right:0;bottom:0;background:none;background-color:none}.accusation-service-userReport-frame-20aGh{position:relative;width:100%;height:100%;border:none}", ""]);

// Exports
exports.locals = {
	"userReport-mask": "accusation-service-userReport-mask-1ZfsV",
	"userReport-container": "accusation-service-userReport-container-2bvLY",
	"userReport-frame": "accusation-service-userReport-frame-20aGh"
};